import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import moment from 'moment';
import { IUserProfileContext, UserProfileContext } from '../../../../../../../userProfileState/userProfileContext';

const CreatedField = () => {
	const { userForUserInfo } = useContext<IUserProfileContext>(UserProfileContext);

	const inputValue = userForUserInfo?.insertedDate
		? `${moment(userForUserInfo.insertedDate).format('MM/DD/YYYY h:mm:ss A')}   ${userForUserInfo.insertedBy}`
		: undefined;

	return <FullInfoField label="createdLabel" value={inputValue} />;
};

export default CreatedField;
